<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="inwardHandlings.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/processes/inward-handlings/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="inwardHandling"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions 
            :inwardHandling="scope.row" 
            @show-customer-order-dialog="$emit('show-customer-order-dialog', $event)"
            @show-representative-order-dialog="$emit('show-representative-order-dialog', $event)"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="inwardHandlings.per_page"
        layout="total, prev, pager, next"
        :total="inwardHandlings.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels, compareTypes } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'asc',
      },
    };
  },
  computed: {
    inwardHandlings() {
      return this.$store.getters['inwardHandling/inwardHandlings'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['inwardHandling/tableConfig']));
    },
    loading() {
      return this.$store.getters['inwardHandling/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('inwardHandling/setFilterString', '');
    this.$store.commit('inwardHandling/setCurrentPage', this.currentPage);
    this.$store.commit('inwardHandling/setSorting', this.currentSort);
    await this.$store.dispatch('inwardHandling/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('inwardHandling/setCurrentPage', val);
      this.$store.dispatch('inwardHandling/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('inwardHandling/setSorting', { prop, order, compareType: compareTypes[prop] || 'string' });
        this.$store.dispatch('inwardHandling/fetchAll');
      }
    },
  },
};
</script>
<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
